module.exports = __webpack_public_path__ + "img/sliders-01.4577b326.jpg";